



































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import UploadImage from "@/shared/components/UploadImage/Index.vue";
import TinyMceEditor from "@/shared/components/TinymceEditor/index.vue";
import {FormModel} from "ant-design-vue";
import {ArticleStore} from "@/modules/article/store";
import {assignValueToForm} from "@/shared/services/helper/utils";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";

const form = {
    id: "",
    name: "",
    author: "",
    description: "",
    content: "",
    thumbnail: "",
    thumbnailUrl: "",
    postOfficeRowGuid: undefined,
    status: undefined
}
@Component({
    name: "ArticleForm",
    components: {AInputCustom, EnumSelector, PostOfficeSelector, TinyMceEditor, UploadImage}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly id!: number;

    CommonStatus = CommonStatus;
    form = { ...form };
    rules = {
        name: [{ required: true, message: "Nhập tên bài viết", trigger: "change" }],
        author: [{ required: true, message: "Nhập tên tác giả", trigger: "change" }],
        description: [{ required: true, message: "Nhập mô tả bài viết", trigger: "change" }],
        content: [{ required: true, message: "Nhập nội dung bài viết", trigger: "change" }],
        thumbnail: [{ required: true, message: "Ảnh đại diện bài viết", trigger: "change" }]
    }

    async created() {
        if (this.id) {
            try {
                const data = await ArticleStore.singleArticle(this.id);
                this.form = assignValueToForm(this.form, data);
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }

    onSubmit() {
        (this.$refs.formArticle as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.id
                    ? await ArticleStore.editArticle(this.form)
                    : await ArticleStore.createArticle(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} tin tức thành công`
                });
                this.$router.push({name: "articleList"});
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} tin tức thất bại`}`)
            }
        })
    }
}
